




































































































import { mapGetters, mapState } from 'vuex';
import { PropType } from 'vue';
import * as vr from '@/helpers/validation';
import { tradingSettings, saveTradingSettings } from '@/api/BlockchainWallet';
import { errorToastMessage } from '@/helpers/errorToastMessage';

import type { TradingSettings } from '@/api/schema';
import type { AxiosError } from 'axios';

interface TradingSettingsState {
  processing: boolean;
  tradingSettings: TradingSettings;
  formIsValid: boolean;
}

export default {
  name: 'SuperAdminTokenManagementTradingSettings',
  props: {
    showDialog: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  data: (): TradingSettingsState => ({
    processing: false,
    tradingSettings: {} as TradingSettings,
    formIsValid: true
  }),
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    ...mapState('Auth', ['tokenSymbol']),
    rules(): unknown {
      return [vr.required, vr.validNumber, (v) => vr.gte(v, 0)];
    }
  },
  watch: {
    operatorId: {
      handler(newId: number | null): void {
        if (newId) {
          this.getTradingSettings();
        }
      },
      immediate: true
    },
    showDialog(status: boolean): void {
      if (!status) {
        this.getTradingSettings();
      }
    }
  },
  methods: {
    getTradingSettings(): void {
      this.processing = true;
      tradingSettings()
        .then((data: TradingSettings) => {
          this.tradingSettings = data;
          this.$refs.form?.resetValidation();
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally((): void => {
          this.processing = false;
        });
    },
    saveSettings(): void {
      const form = this.$refs.form;
      form.validate();
      this.$nextTick((): void => {
        if (!this.formIsValid) return;
        this.processing = true;
        saveTradingSettings(this.tradingSettings)
          .then((data: TradingSettings) => {
            this.tradingSettings = data;
            this.$toast.success('Trading Wallet settings are updated');
            this.$emit('closeDialog');
          })
          .catch((err: AxiosError): void => {
            errorToastMessage(err);
          })
          .finally((): void => {
            this.processing = false;
          });
      });
    }
  }
};
